module.exports = __webpack_public_path__ + "static/media/gear-icon.97ca7fed.png";